import { defineStore } from 'pinia'
import { ref } from 'vue'
import store2 from 'store2'

const defaultMenus = [
  { name: 'Dashboard', routeName: 'home', filterName: 'Home', isShow: true, type: 0 },
  { name: 'SOP Score/class', routeName: 'SOP', filterName: 'sop', isShow: true, type: 0 },
  { name: 'Class Table', routeName: 'classTab', filterName: 'ClassTable', isShow: true, type: 0 },
  {
    name: 'Training Center',
    routeName: 'trainingCenter',
    filterName: 'TrainingCenter',
    isShow: true,
    type: 0,
    enableFolder: true
  },
  { name: 'Service Fee', routeName: 'serviceFee', filterName: 'ServiceFee', isShow: true, type: 0 },
  {
    name: 'Student Comment',
    routeName: 'comments',
    filterName: 'StudentComment',
    isShow: true,
    type: 0,
    enableFolder: true
  },
  {
    name: 'Assessment',
    routeName: 'complaintList',
    filterName: 'ComplaintList',
    isShow: true,
    type: 0,
    enableFolder: true
  },
  {
    name: 'Feedback',
    routeName: 'myFeedback',
    filterName: 'myFeedback',
    isShow: true,
    type: 0,
    enableFolder: true
  },
  // 旧站 defaultMenus 已注释 My Referrals，侧栏不展示；路由 /referrals* 仍保留
  { name: 'Home', routeName: 'home', filterName: 'Home', type: 1 },
  { name: 'Login', routeName: 'login', filterName: 'Login', type: 1 },
  { name: 'PersonalData', routeName: 'newPersonalData', filterName: 'PersonalData', type: 1 },
  { name: 'Message', routeName: 'message', filterName: 'Message', type: 1 },
  { name: 'Flowers', routeName: 'flowers', filterName: 'Flowers', type: 1 },
  { name: 'Welcome', routeName: 'welcome', filterName: 'Welcome', type: 1 }
]

function trimEndSlash(str) {
  return String(str || '').replace(/\/+$/, '')
}

function getMenu() {
  const cached = store2.get('mainMenus')
  if (!Array.isArray(cached) || !cached.length) {
    return defaultMenus.map((m) => ({ ...m }))
  }
  // 对齐旧站：My Referrals 不在侧栏
  const filtered = cached.filter(
    (m) => m.routeName !== 'referrals' && m.routeName !== 'myReferrals'
  )
  const byRoute = new Map(filtered.map((m) => [m.routeName, m]))
  defaultMenus.forEach((def) => {
    if (!byRoute.has(def.routeName)) {
      filtered.push({ ...def })
      byRoute.set(def.routeName, def)
    }
  })
  store2.set('mainMenus', filtered)
  return filtered
}

/** Sidebar menus — aligned with Tutor.Web defaultMenus */
export const useLayoutStore = defineStore('layout', () => {
  // Tutor.Web: user.sidebarMenuMini = true （默认折叠）
  const sidebarCollapsed = ref(true)
  const mainMenus = ref(getMenu())
  const whiteList = ref([])
  const feedbackDialog = ref({ dialog: false, id: '' })
  const cashDialog = ref({ dialog: false })
  const levelDialog = ref({ dialog: false })
  const reportDialog = ref({ dialog: false })
  const emailDialog = ref({ dialog: false })
  const growthValuesDialog = ref({ dialog: false })
  const enrolmentDialog = ref({ dialog: false })

  function toggleSidebar() {
    sidebarCollapsed.value = !sidebarCollapsed.value
  }

  function setSidebarCollapsed(value) {
    sidebarCollapsed.value = !!value
  }

  function setMenu(hosts) {
    if (!hosts) return
    const menus = defaultMenus.map((t) => {
      const item = { ...t }
      const path = hosts[t.filterName]
      if (path) {
        item.url = `${trimEndSlash(path)}/${t.routeName}`
      }
      return item
    })
    mainMenus.value = menus
    store2.set('mainMenus', menus)
    whiteList.value = hosts.WhiteList || []
  }

  function openFeedbackDialog(id = '') {
    feedbackDialog.value = { dialog: true, id: id || '' }
  }

  function closeFeedbackDialog() {
    feedbackDialog.value = { dialog: false, id: '' }
  }

  function setFeedbackDialog(data) {
    feedbackDialog.value = {
      dialog: !!data?.dialog,
      id: data?.id || ''
    }
  }

  function openCashDialog() {
    cashDialog.value = { dialog: true }
  }

  function closeCashDialog() {
    cashDialog.value = { dialog: false }
  }

  function openLevelDialog() {
    levelDialog.value = { dialog: true }
  }

  function closeLevelDialog() {
    levelDialog.value = { dialog: false }
  }

  function openReportDialog() {
    reportDialog.value = { dialog: true }
  }

  function closeReportDialog() {
    reportDialog.value = { dialog: false }
  }

  function openEmailDialog() {
    emailDialog.value = { dialog: true }
  }

  function closeEmailDialog() {
    emailDialog.value = { dialog: false }
  }

  function openGrowthValuesDialog() {
    growthValuesDialog.value = { dialog: true }
  }

  function closeGrowthValuesDialog() {
    growthValuesDialog.value = { dialog: false }
  }

  function openEnrolmentDialog() {
    enrolmentDialog.value = { dialog: true }
  }

  function closeEnrolmentDialog() {
    enrolmentDialog.value = { dialog: false }
  }

  return {
    sidebarCollapsed,
    mainMenus,
    whiteList,
    feedbackDialog,
    cashDialog,
    levelDialog,
    reportDialog,
    emailDialog,
    growthValuesDialog,
    enrolmentDialog,
    toggleSidebar,
    setSidebarCollapsed,
    setMenu,
    openFeedbackDialog,
    closeFeedbackDialog,
    setFeedbackDialog,
    openCashDialog,
    closeCashDialog,
    openLevelDialog,
    closeLevelDialog,
    openReportDialog,
    closeReportDialog,
    openEmailDialog,
    closeEmailDialog,
    openGrowthValuesDialog,
    closeGrowthValuesDialog,
    openEnrolmentDialog,
    closeEnrolmentDialog,
  }
})
